import { render, staticRenderFns } from "./FileImage.vue?vue&type=template&id=bb80f2ca&scoped=true&lang=pug"
import script from "./FileImage.vue?vue&type=script&lang=js"
export * from "./FileImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb80f2ca",
  null
  
)

export default component.exports